export default {
      id: "countryFlag-United_Kingdom-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#countryFlag-United_Kingdom",
      toString: function () {
        return this.url;
      }
    }